(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.moneyFormat) {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  document.querySelectorAll('[data-section-type="product"]').forEach(function (root) {
    var qtyInput = root.querySelector('[data-pp-quantity]');
    var variantIdInput = root.querySelector('[data-pp-variant-id]');
    if (!qtyInput || !variantIdInput) return; // not a photo-printing buy box

    var customMinimum = parseInt(qtyInput.getAttribute('data-pp-custom-min'), 10) || 1;
    var packageButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pp-variant]'));
    var customWrap = root.querySelector('[data-pp-custom]');
    var customCountEl = root.querySelector('[data-pp-custom-count]');
    var customDecrease = root.querySelector('[data-pp-custom-decrease]');
    var customIncrease = root.querySelector('[data-pp-custom-increase]');
    var priceEl = root.querySelector('[data-pp-price]');
    var priceNoteEl = root.querySelector('[data-pp-price-note]');

    var customCount = customMinimum;
    var activeIsCustom = false;
    var activeUnitPrice = 0;

    function updateDisplay() {
      if (activeIsCustom) {
        var count = customCount;
        qtyInput.value = count;
        var total = count * activeUnitPrice;
        if (priceEl) priceEl.textContent = formatMoney(total);
        if (priceNoteEl) {
          priceNoteEl.style.display = '';
          priceNoteEl.textContent = count + ' photos × ' + formatMoney(activeUnitPrice);
        }
        if (customCountEl) customCountEl.textContent = count;
      } else {
        // Flat package variant: always quantity 1, price is the variant's own price
        qtyInput.value = 1;
        if (priceEl) priceEl.textContent = formatMoney(activeUnitPrice);
        if (priceNoteEl) priceNoteEl.style.display = 'none';
      }
    }

    function selectVariant(btn) {
      if (btn.hasAttribute('data-pp-unavailable')) return;

      packageButtons.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');

      variantIdInput.value = btn.getAttribute('data-pp-variant');
      activeUnitPrice = parseInt(btn.getAttribute('data-pp-variant-price'), 10) || 0;
      activeIsCustom = btn.getAttribute('data-pp-is-custom') === 'true';

      if (customWrap) customWrap.classList.toggle('hide', !activeIsCustom);
      if (activeIsCustom) customCount = Math.max(customMinimum, customCount);

      updateDisplay();
    }

    packageButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { selectVariant(btn); });
    });

    if (customDecrease) {
      customDecrease.addEventListener('click', function () {
        customCount = Math.max(customMinimum, customCount - 1);
        updateDisplay();
      });
    }

    if (customIncrease) {
      customIncrease.addEventListener('click', function () {
        customCount += 1;
        updateDisplay();
      });
    }

    // Initialize from whichever button is marked selected on page load
    var initialBtn = root.querySelector('[data-pp-variant].is-selected') || packageButtons[0];
    if (initialBtn) {
      activeUnitPrice = parseInt(initialBtn.getAttribute('data-pp-variant-price'), 10) || 0;
      activeIsCustom = initialBtn.getAttribute('data-pp-is-custom') === 'true';
      if (activeIsCustom) customCount = customMinimum;
      updateDisplay();
    }
  });
})();
